import React from 'react'
import { Box, Link, Text } from '@workwhile/ui'
import { IssueSection } from './IssueSection'
import { useInvoiceIssuesContextValue } from '../context/InvoiceIssuesProvider'
import * as ROUTES from 'constants/routes'

export const MissingDepartmentSection = () => {
  const {
    state: {
      data: { missingDepartment },
    },
  } = useInvoiceIssuesContextValue()

  return (
    <IssueSection
      title="Missing department on positions"
      description="Companies that bill by department, but have positions with no department set."
      emptyMessage="No companies with missing department positions."
      isEmpty={missingDepartment.length === 0}
    >
      {missingDepartment.map((issue) => (
        <Box
          key={issue.company.id}
          border="1px solid"
          borderColor="neutrals.100"
          borderRadius="small"
          p={3}
          mb={2}
        >
          <Text fontWeight="500" mb={1}>
            <Link
              to={ROUTES.COMPANY_DETAIL.replace(
                ':companyId',
                String(issue.company.id)
              )}
            >
              {issue.company.name}
            </Link>{' '}
            ({issue.company.id}) — {issue.shiftCount} shift
            {issue.shiftCount === 1 ? '' : 's'}
          </Text>
          {issue.positions.map((position) => (
            <Text key={position.id} color="lightText" ml={2}>
              {position.name} ({position.id}) — {position.shiftCount} shift
              {position.shiftCount === 1 ? '' : 's'}
            </Text>
          ))}
        </Box>
      ))}
    </IssueSection>
  )
}
